
import {
    ApiManager,
    SessionManager,
    sessionService,
    LoggerUtility,
    EnumUtility,
    UtilityLibrary
} from '../components/ComponentsLibrary';

class BatchDataService {
        static getMasterDBSchema() {
        return SessionManager.GetDataFromSession("SiteSettingsDetailsKey")?.masterDBSchema;
    }
    constructor() {
        if (!BatchDataService.batchInstance) {
            this.cachedData = null;
            this.batchDocData = {
                activityStartTS: null,
                activityTypeID: 0,
                userLoginID: 0,
                fKM_UserLoginID: 0,
                orgID: 0,
                batchStatusID: 0,
                batchStatus: 0,
                batchID: 0,
                batchName: "",
                batchPath: "",
                batchDocumentID: 0,
                newBatchDocumentID: 0,
                docGroupID: 0,
                documentTypeID: 0,
                documentStatusID: 0,
                documentName: "",
                documentLocation: "",
                notes: "",
                narrative: "",
                yTracCaseID: 0,
                newYTracCaseID: 0,
                caseNumber: "",
                nocase: 0,
                indexingCompleteTS: null,
                docQueueID: 0,
                fKM_ScanUserLoginID: null,
                indexTS: null,
                fKM_IndexUserLoginID: null,
                docPageCount: 0,
                fKM_LastIndexUserLoginID: null,
                lastIndexTS: null,
                documentOrder: 0,
                yTracSiteID: 0,
                documentUNCPath: "",
                masterServerDBSchema: BatchDataService.getMasterDBSchema(),  
                actionStartTime: null,
                fKM_YTracSiteID: 0,
                caseWorker: "",
                cPMemberID: "0",
                nCPMemberID: "0",
                directionTypeID: 0,
                integrationID: 0,
                documentOrderID: 0,
                isSplit: 0,
                newActivityID: 0
            };
            this.docSplitData = {
                batchInstance: null,
                newBatchID: 0,
                currentDateTimeString: "",
                splitDocumentFileName: "",
                currentDocumentFileName: "",
                documentUNCPath: "",
                currentDocument_Blob: "",  // This is the Blob of the current document after pages have been removed.
                splitOffDocument_Blob: "",  // This is the Blob of the split off document.
                basePath: "", // This is the path to the base folder on the server.
                currentDocumentbatchPath: "", // This is the batch path of the current document on the server.
                splitOffDocumentbatchPath: "", // This is the batch path of the split off document on the server.
                splitOffBuffer: "",                
                docQueueID: 0,
            }
            BatchDataService.batchInstance = this;
        }
        return BatchDataService.batchInstance;
    }    

    // Method to update cached data
    setCachedData(newData) {
        this.cachedData = newData;
    }

    // Method to update Batch Document data
    updateBatchDocumentData(newBatchDocData) {
        const updatedBatchDocData = { ...this.batchDocData, ...newBatchDocData }; // Merge new batch document data with existing document data;
        this.batchDocData = updatedBatchDocData;
    }

    // Method to update Batch Document data
    updateDocSplitData(newdocSplitData) {
        const updatedDocSplitData = { ...this.docSplitData, ...newdocSplitData }; // Merge new 
        this.docSplitData = updatedDocSplitData;
    }

    getCachedData() {
        return this.cachedData; // Return the cached data
    }

    getBatchDocumentData() {
        return this.batchDocData; // Return the current batch document data
    }    

    getSplitDocumentData() {
        return this.docSplitData; // Return the current split document data
    }


    async InsertBatchDocument(currentBatchDocumentID, pageCount, batchid, customOptions = {}) {
        try {
            const loginUserInfo = sessionService.getUser();
            const loginLegacyUserID = loginUserInfo ? loginUserInfo.legacyUserID : -123456;
            const loginStateID = loginUserInfo ? loginUserInfo.stateID : -123456;

            console.log("InsertBatchDocument");

            const paramsBatchDoc = {
                batchDocumentID: currentBatchDocumentID
            }

            const batchDocApiData = await ApiManager.GetBatchDocumentByIDFromApi(paramsBatchDoc);
            
            // New Document being created in the current or new Batch
            // uniqueSuffix guarantees a unique file name when multiple documents are created in quick
            // succession (e.g. Split All), since the timestamp alone only has second-level resolution.
            const currentDateTimeString = UtilityLibrary.getCurrentDateTimeString() + (customOptions.uniqueSuffix ? `_${customOptions.uniqueSuffix}` : "");
            const initialNewDocData = this.getBatchDocumentData();
            const docSplitData = this.getSplitDocumentData();
            const docLocation = currentDateTimeString + ".pdf";

            if (customOptions.origin === "CaseInformation") {

                // orderOffset lets callers create multiple documents behind the original in page order (e.g. Split All).
                initialNewDocData.documentOrder = batchDocApiData.documentOrder + (customOptions.orderOffset || 1);
                docSplitData.currentDocumentbatchPath = batchDocApiData.batchPath;

            } else if (customOptions.origin === "DocumentSearch") {

                initialNewDocData.documentOrder = 1;
                docSplitData.splitOffDocumentbatchPath = currentDateTimeString.slice(0, 4) + "\\" + currentDateTimeString.slice(4, 4 + 2) + "\\" + currentDateTimeString.slice(6, 6 + 2) + "\\" + batchid;
            }

            initialNewDocData.batchID = batchid;  // The value passed in from the function call. This is either the current batchID or the new batchID.
            initialNewDocData.batchDocumentID = null;
            initialNewDocData.newBatchDocumentID = null;
            initialNewDocData.batchStatusID = 32;
            initialNewDocData.batchStatus = 32;
            initialNewDocData.documentName = "Nutrient_Split_" + initialNewDocData.batchID + "_" + currentDateTimeString;
            initialNewDocData.documentLocation = docLocation;
            initialNewDocData.isSplit = 1;
            initialNewDocData.lastIndexTS = null;
            initialNewDocData.indexTS = null;
            initialNewDocData.activityStartTS = null;
            initialNewDocData.docPageCount = pageCount;
            initialNewDocData.documentTypeID = null;
            initialNewDocData.fKM_IndexUserLoginID = null;
            initialNewDocData.fKM_LastIndexUserLoginID = null;

            docSplitData.splitDocumentFileName = docLocation;

            const updatedDocValues = {
                ...initialNewDocData,
                userLoginID: loginLegacyUserID,
                fKM_UserLoginID: loginLegacyUserID,
                orgID: loginStateID,
                masterServerDBSchema: BatchDataService.getMasterDBSchema()   
            };

            const postResponseData = await ApiManager.PostBatchDocumentToApi(updatedDocValues);  // Update the current document with the new docPageCount.
            if (postResponseData) {
                this.updateDocSplitData(docSplitData);
                console.log("I hope something good happened here.");
            }
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, "BatchDataService", "InsertBatchDocument");
            //console.log("error: ");
        }

    };


    async UpdateBatchDocument(currentBatchDocumentID, pageCount, batchid, customOptions = {}) {
        try {
            const loginUserInfo = sessionService.getUser();
            const loginLegacyUserID = loginUserInfo ? loginUserInfo.legacyUserID : -123456;
            const loginStateID = loginUserInfo ? loginUserInfo.stateID : -123456;

            console.log("UpdateBatchDocument");

            const paramsBatchDoc = {
                batchDocumentID: currentBatchDocumentID
            }

            const batchDocApiData = await ApiManager.GetBatchDocumentByIDFromApi(paramsBatchDoc);
            const initialNewDocData = this.getBatchDocumentData();
            const docSplitData = this.getSplitDocumentData();

            // Existing Document being updated with new docPageCount

            initialNewDocData.batchID = batchDocApiData.batchID;
            initialNewDocData.newBatchDocumentID = currentBatchDocumentID;
            initialNewDocData.lastIndexTS = batchDocApiData.lastIndexTS;
            initialNewDocData.indexTS = batchDocApiData.indexTS;
            initialNewDocData.activityStartTS = batchDocApiData.activityStartTS;
            initialNewDocData.fKM_UserLoginID = loginLegacyUserID;
            initialNewDocData.fKM_YTracSiteID = loginStateID;
            initialNewDocData.fKM_IndexUserLoginID = batchDocApiData.fkM_IndexUserLoginID;
            initialNewDocData.fKM_LastIndexUserLoginID = batchDocApiData.fkM_LastIndexUserLoginID;
            initialNewDocData.docPageCount = pageCount;
            initialNewDocData.batchStatus = batchDocApiData.documentStatusID;
            initialNewDocData.documentTypeID = batchDocApiData.documentTypeID;
            initialNewDocData.documentName = batchDocApiData.documentName;
            initialNewDocData.documentLocation = batchDocApiData.documentLocation.replace(".tiff", ".pdf").replace(".tif", ".pdf");

            const updatedDocValues = {
                ...initialNewDocData,
                userLoginID: loginLegacyUserID,
                orgID: loginStateID,
                masterServerDBSchema: BatchDataService.getMasterDBSchema(),  
            };

            docSplitData.currentDocumentFileName = initialNewDocData.documentLocation;
            docSplitData.currentDocumentbatchPath = batchDocApiData.batchPath;
            docSplitData.docQueueID = batchDocApiData.docQueueID;

            const postResponseData = await ApiManager.PostBatchDocumentToApi(updatedDocValues);  // Update the current document with the new docPageCount.
            if (postResponseData) {
                this.updateDocSplitData(docSplitData);
                console.log("I hope something good happened here.");
            }
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, "BatchDataService", "UpdateBatchDocument");
           // console.log("error: ");
        }
    };

    async InsertBatch() {
        try {
            // TODO use the props.BatchID to get the current Batch record and then copy the docQueueID from it.
            // TODO Figure out where to get the integrationID from. 

            const loginUserInfo = sessionService.getUser();
            const loginLegacyUserID = loginUserInfo ? loginUserInfo.legacyUserID : -123456;
            const loginStateID = loginUserInfo ? loginUserInfo.stateID : -123456;
            // const currentDateTime = new Date().toISOString();
            const docSplitData = this.getSplitDocumentData();

            let integrationID = SessionManager.GetValueFromSession(SessionManager.IntegrationIDKey);
            integrationID = integrationID ? parseInt(integrationID) : 0;

            // Get the original batch information to preserve document source in batch name
            const originalBatchDocData = this.getBatchDocumentData();
            let batchName = "Split Document Batch";
            
            // Try to get batch list to find the original batch name and preserve document source
            try {
                const batchListData = await ApiManager.GetBatchListFromApi();
                const originalBatch = batchListData.find(b => b.batchID === originalBatchDocData.batchID);
                if (originalBatch && originalBatch.batchName) {
                    batchName = originalBatch.batchName;
                }
            } catch (error) {
                // If batch list fails, fallback to default naming but log the error
                console.warn("Failed to retrieve original batch name for document source preservation:", error);
            }

            const updatedBatchValues = {
                statusTypeID: 28,      // TO-DO: Modify Code -- use enum
                fKM_UserLoginID: 0,
                batchName: batchName,
                indexingCompleteTS: null,
                newBatchID: null,
                docQueueID: docSplitData.docQueueID,     
                fKM_ScanUserLoginID: null,
                integrationID: integrationID,    
                masterServerDBSchema: BatchDataService.getMasterDBSchema(),  
            }
            const postResponseData = await ApiManager.PostBatchInsertUpdateToApi(updatedBatchValues);

            //newBatchID = postResponseData.batchID;
            // assign the newBatchID from the response data.
            if (postResponseData) {
                docSplitData.newBatchID = postResponseData[0].batchID;
                this.updateDocSplitData(docSplitData);
                console.log("New batch created - ID:", docSplitData.newBatchID, "Name:", batchName);
            }           

            console.log("Inserted Batch");

        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, "BatchDataService", "InsertBatch");
           // console.log("error: ");
        }


    };

}

const batchDataService = new BatchDataService();
//Object.freeze(batchDataService); // Prevent modifications to the instance

export default batchDataService;